import type { DepenseCategorie, ModePaiement } from '@/services/depenses';

/** Libellés français lisibles pour les catégories de dépense. */
export const CATEGORIE_LABEL: Record<DepenseCategorie, string> = {
  MATERIAUX: 'Matériaux',
  CARBURANT: 'Carburant',
  LOCATION_MATERIEL: 'Location matériel',
  SOUS_TRAITANCE: 'Sous-traitance',
  FOURNITURES_BUREAU: 'Fournitures de bureau',
  FRAIS_ADMINISTRATIFS: 'Frais administratifs',
  TRANSPORT: 'Transport',
  ASSURANCE: 'Assurance',
  IMPOTS_TAXES: 'Impôts & taxes',
  HONORAIRES: 'Honoraires',
  TELECOMMUNICATIONS: 'Télécommunications',
  ENERGIE: 'Énergie',
  ENTRETIEN_REPARATION: 'Entretien & réparation',
  AUTRE: 'Autre',
};

export const MODE_PAIEMENT_LABEL: Record<ModePaiement, string> = {
  ESPECES: 'Espèces',
  CHEQUE: 'Chèque',
  VIREMENT: 'Virement',
  CARTE: 'Carte',
  PRELEVEMENT: 'Prélèvement',
};
